import { render, staticRenderFns } from "./RecebimentoItemInfoSituacao.vue?vue&type=template&id=30ed5f6b&scoped=true"
import script from "./RecebimentoItemInfoSituacao.vue?vue&type=script&lang=ts"
export * from "./RecebimentoItemInfoSituacao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ed5f6b",
  null
  
)

export default component.exports